import React from 'react';
import './Input.css';

const Input = ({
  type = 'text',
  placeholder,
  value,
  onChange,
  className = '',
  label,
  error,
  ...props
}) => {
  const inputId = label ? `input-${label.toLowerCase().replace(/\s+/g, '-')}` : undefined;
  const hasError = !!error;

  return (
    <div className={`linear-input-wrapper ${className}`.trim()}>
      {label && (
        <label htmlFor={inputId} className="linear-input-label">
          {label}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        className={`linear-input ${hasError ? 'linear-input--error' : ''}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...props}
      />
      {error && (
        <span className="linear-input-error">{error}</span>
      )}
    </div>
  );
};

export default Input;


